import { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import ChangeTutorAppointments from "../../../views/tutor/ChangeTutorAppointments";
import ActiveRequestGroupModel from "../../../api/models/ActiveRequestGroupModel";
import CalendarScheduleSlotModel from "../../../models/CalendarScheduleSlotModel";
import {
  createProposedRecitation,
  getActiveRequestGroups,
} from "../../../api/endpoints/tutors/proposedSchedules";
import LoadingSpinner from "../../LoadingSpinner";
import ApiDateParser from "../../../helpers/parsers/apiDateParser";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";

type ChangeTutorStudentAppointmentsModalProps = {
  open: boolean;
  setOpen: any;
  activeRequest?: ActiveRequestGroupModel;
  setActiveRequest: any;
};
export default function ChangeTutorStudentAppointmentsModal(
  props: ChangeTutorStudentAppointmentsModalProps
) {
  const { setOpen, open, setActiveRequest, activeRequest } = props;
  const [touterRequest, setTouterRequest] = useState<ActiveRequestGroupModel>(
    activeRequest!
  );
  const [isLoading, setIsLoading] = useState<Boolean>(false!);
  const navigate = useNavigate();
  useEffect(() => {
    if (touterRequest!.remianing_students?.length == 0) {
      setOpen(false);
    }
  }, [touterRequest]);

  const [selectedSlots, setSelectedSlots] = useState<
    CalendarScheduleSlotModel[]
  >([]);

  const handleSubmit = async () => {
    setIsLoading(true);
    const newSlots: any = [];
    selectedSlots.forEach((slot) => {
      if (slot != null) {
        let slotData = {
          start_time: ApiDateParser.normalize(
            ApiDateParser.toApiDate(slot.startTime)
          ),
          end_time: ApiDateParser.normalize(
            ApiDateParser.toApiDate(slot.endTime)
          ),
          day_of_the_week: slot.dayOfWeekName,
          schedule_slot_id: slot.id,
          date: slot.date,
        };
        newSlots.push(slotData);
      }
    });

    var data = { schedule_slots_attributes: newSlots };
    const response = await createProposedRecitation(
      touterRequest!.remianing_students![0].id,
      data
    );
    if (response.isSuccess) {
      const responseActive = await getActiveRequestGroups();
      const newTouterRequest = new ActiveRequestGroupModel(responseActive.data);
      setTouterRequest(newTouterRequest);
      setActiveRequest(newTouterRequest);
      if (newTouterRequest.remianing_students?.length == 0) {
        setOpen(false);
        navigate("/tutor/dashboard/appointments-requests/true");
      }

      setIsLoading(false);
    }
    // TODO: call api to create proposed schedule for student
  };
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => setOpen(false)}>
        <div className="fixed inset-0" />
        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full ">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen  h-screen">
                  <div className="flex h-full flex-col overflow-hidden bg-white  shadow-xl">
                    <div className="px-4 sm:px-6">
                      <div className="flex items-start justify-between"></div>
                    </div>
                    <div className="relative  flex-1 px-4 sm:px-6">
                      {/* Replace with your content */}
                      {isLoading ? (
                        <>
                          <div className="flex justify-center items-center w-screen h-screen">
                            <LoadingSpinner size={60} />
                          </div>
                        </>
                      ) : (
                        <>
                          {!!activeRequest &&
                            !!touterRequest!.remianing_students![0] && (
                              <ChangeTutorAppointments
                                setOpen={() => setOpen(false)}
                                student={touterRequest!.remianing_students![0]}
                                selectedSlots={selectedSlots}
                                setSelectedSlots={setSelectedSlots}
                                handleSubmit={handleSubmit}
                              />
                            )}
                        </>
                      )}
                      {/* /End replace */}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
